export const categories = [
  {
    id: 'online',
    name: '网购电商',
    short: '网购',
    desc: '预售套路、虚假促销、退货扯皮，下单前的第一道关卡。',
    icon: 'ri-shopping-bag-3-line',
    count: 24,
  },
  {
    id: 'beauty',
    name: '美妆护肤',
    short: '美妆',
    desc: '成分虚标、代购翻车、智商税话术，别为营销买单。',
    icon: 'ri-drop-line',
    count: 18,
  },
  {
    id: 'tech',
    name: '数码家电',
    short: '数码',
    desc: '参数注水、翻新充新、延保陷阱，买前先对表。',
    icon: 'ri-smartphone-line',
    count: 16,
  },
  {
    id: 'food',
    name: '食饮健康',
    short: '食饮',
    desc: '配料表猫腻、临期混卖、直播间话术，入口的更要较真。',
    icon: 'ri-restaurant-2-line',
    count: 14,
  },
  {
    id: 'travel',
    name: '旅宿出行',
    short: '旅宿',
    desc: '低价机票、民宿照骗、行程捆绑，出发前先把坑标出来。',
    icon: 'ri-flight-takeoff-line',
    count: 13,
  },
  {
    id: 'edu',
    name: '教育培训',
    short: '教育',
    desc: '保过承诺、分期贷、退费难，签字前务必看清条款。',
    icon: 'ri-book-open-line',
    count: 11,
  },
  {
    id: 'finance',
    name: '金融理财',
    short: '理财',
    desc: '高息诱导、荐股收费、理财话术，收益越美越要冷静。',
    icon: 'ri-safe-2-line',
    count: 12,
  },
  {
    id: 'home',
    name: '家装维修',
    short: '家装',
    desc: '报价增项、材料掉包、上门维修乱收费，验收是关键。',
    icon: 'ri-home-gear-line',
    count: 10,
  },
];

export const riskLevels = [
  { id: 'high', name: '高风险', desc: '涉及明显资金损失或维权困难' },
  { id: 'mid', name: '中风险', desc: '容易吃亏但多数可协商解决' },
  { id: 'low', name: '低风险', desc: '体验受损为主，注意即可避开' },
];